import { enumChartElement } from "../constants";
import { QDragPanelDraggerBoxElement } from "./QDragPanelDraggerBoxElement";
import { QElement } from "./QElement";
import { QElementDragPanel } from "./QElementDragPanel";

export class QOrphanDraggerPanel extends QElementDragPanel {
  constructor() {
    super();
    this.fWSMgr = null;
    this.fRenderPhoenix = false;
  }

  InitializeDragExtras() {
    this.fDestPanel.SetDropMode(true);
  }

  CreateDragElement() {
    var boxElement = new QDragPanelDraggerBoxElement();
    boxElement.InitPanelDraggerBox(this);
    boxElement.SizeElement(120 * this.fDestPanel.fScaleFactor, 60 * this.fDestPanel.fScaleFactor);
    return boxElement;
  }

  HandleTargetHit(controlElement, x, y) {
    var hitTest = this.fDestPanel.HitTest(x, y, null);
    var isValid = false;
    if (hitTest.fPanelHit != null) {
      this.fDestPanel.ClearSelection();
      var theElement = hitTest.fElementHit;
      var validElement =
        theElement != null &&
        (theElement.GetElementType() == enumChartElement.chartBox ||
          theElement.GetElementType() == enumChartElement.scArrow ||
          theElement.GetElementType() == enumChartElement.boxCell);
      if (validElement) {
        if (theElement.GetElementType() == enumChartElement.boxCell)
          theElement = theElement.fParentBox;

        this.fDestPanel.DragOver(theElement, x); // DoSelectElement(theElement, true);
        isValid = true;
      } else this.fDestPanel.ClearDragOver();
    }
    return isValid;
  }

  DragComplete() {
    if (this.NoDrag()) {
      var doSelect = true;
      if (this.fShiftDown) doSelect = !this.fWasSelected;
      else this.fSrcPanel.ClearSelection();

      this.fSrcPanel.DoSelectElement(this.fSourceElement, doSelect);
    } else {
      this.fWSMgr.StartCheckPoint();
      this.fDestPanel.AttachOrphans(this.fSourceElement.GetDataObj());
      this.fWSMgr.EndCheckPoint();
      this.fSrcPanel.UpdatePanel();
    }

    this.fDestPanel.SetDropMode(false);
  }
}
